import React, {useState, useEffect} from 'react';
import md5 from 'blueimp-md5';
import {Modal, Upload, Button, Radio, Checkbox, Select ,Spin} from 'antd';
import 'antd/lib/modal/style/css';
import 'antd/lib/upload/style/css';
import 'antd/lib/button/style/css';
import 'antd/lib/radio/style/css';
import 'antd/lib/checkbox/style/css';
import 'antd/lib/select/style/css';
import 'antd/lib/spin/style/css';

import { UploadOutlined } from '@ant-design/icons';
import reqwest from 'reqwest';

import Icon from './../basic-icon';
import './index.less';

import * as Api from './../../api';

const Option = Select.Option;

export default (props) => {
    const ref = React.useRef();
    const [domain, setDomain] = useState({});
    const [files, setMainFiles] = useState([]);
    const [tags, setTags] = useState([]);
    const [attached, setAttachedFiles] = useState([]);
    const [disabled, setDisabled] = useState(true);
    const [loading, setLoading] = useState(false);
    // const [rule, setArticleRule] = useState(1);

    const [compare, setCompare] = useState({
        title: {error: true, message: ""},
        catetory: {error: true, message: ""},
        file: {error: true, message: ""},
    });

    useEffect(() => {
        Api.getArticleTags().then((data) => {
            setTags(data);
        });
    }, []);

    const compareToTitle = (value) => {
        if(value.length === 0) {
            setDomain(Object.assign({}, domain, {
                title: value
            }));
            setCompare(Object.assign({}, compare, {
                title: { error: true, message: "请输入文章标题!"}
            }));
            setDisabled(true);

        } else if(value.length < 5 || value.length > 50) {
            setDomain(Object.assign({}, domain, {
                title: value
            }));
            setCompare(Object.assign({}, compare, {
                title: { error: true, message: "文章标题长度必须在【5 - 50】之间！"}
            }));
            setDisabled(true);

        } else {
            setCompare(Object.assign({}, compare, {
                title: { error: false, message: ""}
            }));

            setDomain(Object.assign({}, domain, {
                title: value
            }));

            compareToSome(['catetory', 'file']);
        }
    }

    const compareToSelect = (value) => {
        if(!value) {
            setCompare(Object.assign({}, compare, {
                catetory: { error: true, message: "请选择文章分类！"}
            }));
            setDisabled(true);
        } else {
            setCompare(Object.assign({}, compare, {
                catetory: { error: false, message: ""}
            }));

            setDomain(Object.assign({}, domain, {
                catetoryId: value
            }));

            compareToSome(['title', 'file']);
        }
    }

    const compareToFile = (value) => {

        if(!value.length) {
            setCompare(Object.assign({}, compare, {
                file: { error: true, message: "请上传主文件!"}
            }));
            setMainFiles(value);
            setDisabled(true);
        } else {
            setCompare(Object.assign({}, compare, {
                file: { error: false, message: ""}
            }));

            setMainFiles(value);

            compareToSome(['title', 'catetory']);
        }
    }

    const compareToHref = (value) => {

        if(!value) {
            setCompare(Object.assign({}, compare, {
                file: { error: true, message: "请输入链接地址!"}
            }));
            setMainFiles(value);
            setDisabled(true);
        } else {
            setCompare(Object.assign({}, compare, {
                file: { error: false, message: ""}
            }));

            // setMainFiles(value);
            setDomain(Object.assign({}, domain, {
                href: value
            }));

            compareToSome(['title', 'catetory']);
        }
    }

    const compareToSome = (rules) => {
        var flag = false;
        for(var i = 0; i < rules.length; i++) {
            const key = rules[i];
            console.log(key, compare[key].error);
            if(compare[key].error) {
                flag = true;
                break;
            }
        }
        setDisabled(flag);
    }

    const onFinish = () => {
        setLoading(true);
        setDisabled(true);
        const formData = new FormData();
        formData.append('title', domain.title);
        formData.append('fileLabelId', domain.fileLabelId ? JSON.stringify(domain.fileLabelId) : '');
        //上传的文章是会员可见还是游客可见
        formData.append('fileType', domain.rule ? domain.rule : 1);
        //上传的内容是文章类型、音频类型、还是超链接
        formData.append('viewType' , domain.type ? domain.type : 1);
        formData.append('href' , domain.href ? domain.href : '');
        formData.append('catetoryId', domain.catetoryId);
        if(files){
            files.forEach(file => {
                formData.append('firstFile', file);
            });
        }

        attached.forEach(file => {
            formData.append('secondFile', file);
        });

        Api.Insert(formData).then(response => {
            setDisabled(false);
            setLoading(false);
            let result =JSON.parse(response);
            if(result.code == 200){
                Modal.success({
                    title: '信息提示',
                    content: (
                        <div>
                        {/* <p>{response.message}</p> */}
                            <p>发布文章成功，等待审核</p>
                        </div>
                    ),
                    okText:"确认",
                    onOk: () => {
                        props.setArticleModalVisiable(false);
                    },
                });
            }else{
                Modal.error({
                    title: '错误信息',
                    content: (
                        <div>
                        <p>{result.message}</p>
                        </div>
                    ),
                    okText:"确认",
                    onOk: () => {
                    },
                });
            }
        }).catch(error => {
            setDisabled(false);
            Modal.error({
                title: '错误信息',
                content: (
                    <div>
                    <p>{error.message}</p>
                    </div>
                ),
                okText:"确认",
                onOk: () => {
                },
            });
        });
    }

    const asertSize = (file) => {
        const size = file.size / ( 1024 * 1024 );
        if(size >= 1024) {
            Modal.warn({
                title: '文件过大',
                content: <div>
                    请选择小于<span style={{color: 'red'}}>1024m</span>的文件上传
                </div>,
                okText: '确认',
                onOk : ()=>{
                    setAttachedFiles([])
                }
            })
            return false;
        }
        return true;
    }
    
    return (
        <>
        <div className="modal-article">
            <div className="container">
                <h2>发布文章 - {props.category.label} <Icon type="icon-close" onClick={() => {
                    props.setArticleModalVisiable(false);
                }}></Icon></h2>
                <div className="section">
                <form onSubmit={(event)=>{
                    onFinish();
                    event.preventDefault();
                }}>
                    <div className="form-item">
                        <label className="title"><i>*</i>文章标题:</label>

                        <input type="text" placeholder="请输入文章标题"  className="ciqa-input"
                        value = {domain.title || ''}
                        onChange={(event)=>{
                            compareToTitle(event.target.value);
                        }}></input>
                        {compare.title.error ? <div className="error">{compare.title.message}</div> : ""}
                    </div>

                    <div className="form-item form-type">
                    <label className="title"><i>*</i>文章分类:</label>

                        <Select placeholder="请选择文章分类" style={{width: 200}} 
                        onChange={(data) => {
                            compareToSelect(data);
                        }}>
                            {
                                 props.category.children ? props.category.children.map((item, i) => (
                                    <Option key={i} value={item.value}>{item.label}</Option>
                                )) : ''
                            }
                        </Select>
                        
                        {compare.catetory.error ? <div className="error">{compare.catetory.message}</div> : ""}
                    </div>
                    <div className="form-item form-type">
                        <label  className="title">上传类型:</label>
                        <Radio.Group value={domain.type ? domain.type : 1} onChange={(event) => {
                            // setDomain({
                            //     rule: event.target.value
                            // });
                            setDomain(Object.assign({}, domain, {
                                type: event.target.value
                            }));
                        }}>
                            <Radio value={1}>文章</Radio>
                            <Radio value={2}>视频</Radio>
                            <Radio value={3}>超链接</Radio>
                        </Radio.Group>
                    </div>
                    
                    {(domain.type ? domain.type : 1)  == 1 ?
                    <div className="form-item form-type">
                            <label className="title"><i>*</i>主文件上传:</label>
                            <Upload  accept=".pdf" beforeUpload={(file) => {
                                if(asertSize(file)){
                                    if(!domain.title){
                                        // compareToTitle(file.name);
                                        // setCompare(Object.assign({}, compare, {
                                        //     title: { error: false, message: ""}
                                        // }));
                                        // setDomain(Object.assign({}, domain, {
                                        //     title: file.name
                                        // }));
                                    }
                                    compareToFile([file]);
                                }
                                // compareToSome(['catetory', 'file']);
                                return false;
                            }} onRemove={(file) => {
                                compareToFile([]);
                            }} fileList={files}>
                                <Button>
                                    <UploadOutlined /> 请上传主文件(支持PDF)
                                </Button>
                        </Upload> 
                        {compare.file.error ? <div className="error">{compare.file.message}</div> : ""}
                    </div> : 
                    domain.type == 2 ? 
                    <div className="form-item form-type">
                            <label className="title"><i>*</i>主文件上传:</label>
                            <Upload  accept=".mp4" beforeUpload={(file) => {
                                if(asertSize(file)){
                                    if(!domain.title){
                                        // compareToTitle(file.name);
                                        // setCompare(Object.assign({}, compare, {
                                        //     title: { error: false, message: ""}
                                        // }));
                                        // setDomain(Object.assign({}, domain, {
                                        //     title: file.name
                                        // }));
                                    }
                                    compareToFile([file]);
                                }
                                // compareToSome(['catetory', 'file']);
                                return false;
                            }} onRemove={(file) => {
                                compareToFile([]);
                            }} fileList={files}>
                                <Button>
                                    <UploadOutlined /> 请上传视频文件(支持MP4)
                                </Button>
                        </Upload> 
                        {compare.file.error ? <div className="error">{compare.file.message}</div> : ""}
                    </div> : 
                     domain.type == 3 ?
                     <div className="form-item form-type">
                        <label className="title"><i>*</i>链接地址:</label>
                        <input type="text" placeholder="请输入链接地址" className="ciqa-input" style={{lineHeight:'20px'}}
                        value = {domain.href || ''}
                        onChange={(event)=>{
                            setDomain(Object.assign({}, domain, {
                                href: event.target.value
                            }));
                            compareToHref(event.target.value);
                        }}></input>
                        {compare.file.error ? <div className="error">{compare.file.message}</div> : ""}
                     </div> : ''
                    }

                    <div className="form-item form-type">
                        <label  className="title">附件上传:</label>
                        <Upload beforeUpload={(file) => {
                            asertSize(file)
                            setAttachedFiles([...attached, file]);
                            return false;
                        }} onRemove={(file) => {
                            const index = attached.indexOf(file);
                            const newFileList = attached.slice();
                            newFileList.splice(index, 1);
                            setAttachedFiles(newFileList);
                        }} fileList={attached}>
                            <Button>
                                <UploadOutlined /> 请上传附件
                            </Button>
                        </Upload>
                        
                    </div>
                    <div className="form-item form-type">
                        <label  className="title">标签:</label>
                    <ul className="form-tags">
                    <Checkbox.Group value={domain.fileLabelId} onChange={(value) => {
                                const fileLabelId = value;
                                setDomain(Object.assign({}, domain, {
                                    fileLabelId:fileLabelId
                                }));
                                // if(event.target.checked) {
                                //     if(fileLabelId.indexOf(event.target.value) === -1) {
                                //         setDomain({
                                //             fileLabelId: [...fileLabelId, event.target.value]
                                //         });
                                //     }
                                // } else {
                                //     setDomain({
                                //         fileLabelId: fileLabelId.filter(tag => {
                                //             return event.target.value !== tag
                                //         })
                                //     });
                                // }
                                console.log(domain)
                                
                            }}>
                        {tags.map((item, index) => {
                            return <li key={index}><Checkbox value={item.value} >{item.name}</Checkbox></li>
                        })}
                    </Checkbox.Group>
                    </ul>
                    </div>

                    <div className="form-item form-type">
                    <label  className="title">文章类型:</label>
                    <Radio.Group value={domain.rule ? domain.rule : 1} onChange={(event) => {
                        // setDomain({
                        //     rule: event.target.value
                        // });
                        setDomain(Object.assign({}, domain, {
                            rule: event.target.value
                        }));
                    }}>
                        <Radio value={1}>游客可见</Radio>
                        <Radio value={2}>用户可见</Radio>
                    </Radio.Group>
                    </div>
                    
                    <div className="form-item">
                        <button type="submit" className={disabled ? 'ciqa-submit disabled': 'ciqa-submit enabled'} disabled={disabled}>提交审核</button>
                        <Spin style={{marginLeft : '10px'}} tip={'上传中...'} size="small" spinning={loading}></Spin>
                    </div>
                </form>
                </div>
            </div>
        </div>
        <div className="modal-mask"></div>
        </>
    );
}